<template>
  <app-layout title="Billing">
    <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
      <br />
      <!-- progress bar start from here -->
      <div class="container mt-10">
        <ol class="steps">
          <li class="step " data-step="1">Organisation</li>
           <li class="step " data-step="2">Account Setup</li>
          <li class="step is-active" data-step="3">Billing</li>
          <li class="step" data-step="4">Place Order</li>
          <li class="step" data-step="5">Checkout</li>
          <li class="step" data-step="6">Deploy</li>
        </ol>
      </div>
      <!-- progress end  -->
      <div class="row">
        <div class="col-lg-12 mt-4 text-center">
          <h5 class="">Your Billing Accounts</h5>
          <h6 class="text-center">(Select a billing account to proceed)</h6>
          <br />
        </div>
        <!-- <div class="col-lg-3 col-3 text-center">
          <jet-responsive-nav-link
            @click="showCreatePopup()"
            class="hover:no-underline"
          >
            <div
              class="bg-blue-500 p-2 hover:cursor-pointer rounded-full shadow"
              style="display: inline-block"
            >
              <i
                class="
                  fas
                  fa-plus
                  text-white text-xl
                  d-flex
                  justify-content-center
                "
              ></i>
            </div>
          </jet-responsive-nav-link>
        </div> -->
      </div>

      <div class="row">
        <div class="col-lg-12 col-12 text-left">
          <section>
            <div class="grid grid-cols-4 gap-2 mb-4 mt-2">
              <div class="border border-gray-200 bg-white p-2 rounded-lg">
                <div
                  class="bg-white rounded-md card-style text-center py-4 px-1"
                >
                  <h5>Create Billing Account</h5>
                  <br />
                  <br />
                  <br />
                  <br />

                  <!-- <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. </p> -->
                  <button
                    type="button"
                    class="bg-green-500 text-white py-1 px-2 rounded w-full"
                    @click="showCreatePopup()"
                  >
                    Create
                  </button>
                </div>
                <!-- <div>2</div> -->
              </div>

              <div
                class="border border-gray-200 bg-white p-2 rounded-lg"
                v-for="(data, key) in ledgerData"
                :key="key"
              >
                <div
                  class="bg-white rounded-md card-style text-center py-4 px-1"
                >
                  <h5>{{ data["name"] }}</h5>
                  <div :title="data.id" id="elip" class="no-underline">
                    <p class="mb-1 text-black">{{ data.gst_in }}</p>
                  </div>
                  <div
                    v-if="data.rlt_ledger_address.length"
                    :title="
                      data.rlt_ledger_address[0].street +
                      ' , ' +
                      data.rlt_ledger_address[0].area
                    "
                    class="no-underline"
                  >
                    <p class="mb-1 text-gray-500 text-sm ml-2">
                      {{
                        data.rlt_ledger_address[0].street +
                        " , " +
                        data.rlt_ledger_address[0].area +
                        "," +
                        data.rlt_ledger_address[0].landmark +
                        "," +
                        data.rlt_ledger_address[0].city +
                        "," +
                        data.rlt_ledger_address[0].state +
                        "," +
                        data.rlt_ledger_address[0].pin_code
                      }}
                    </p>
                  </div>
                  <!-- <div :title="data.id" id="elip" class="no-underline">
                    <p class="mb-1 text-gray-500 text-sm ml-2">{{ data.rlt_ledger_address[0].city +' , '+ data.rlt_ledger_address[0].state}}</p>
                  </div> -->
                  <!-- <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. </p> -->
                  <button
                    type="button"
                    @click="goToOrderPage(data.id)"
                    class="
                      bg-green-500
                      text-white
                      py-1
                      px-2
                      mt-3
                      rounded
                      w-full
                    "
                  >
                    Select
                  </button>
                </div>
                <!-- <div>2</div> -->
              </div>

              <!-- pop up for quick create -->
              <DxPopup
                v-model:visible="createPopupVisible"
                :drag-enabled="true"
                :show-close-button="true"
                :close-on-outside-click="false"
                :show-title="true"
                :fullscreen="true"
                :resizeEnabled="true"
                :title='"Create Billing Account"'
              >
                <DxToolbarItem
                  widget="dxButton"
                  toolbar="bottom"
                  location="before"
                  :options="saveButtonOptions"
                />
                <DxToolbarItem
                  widget="dxButton"
                  toolbar="bottom"
                  location="after"
                  :options="closeButtonOptions"
                />
                <DxScrollView width="100%" height="100%">
                  <BsOnBoardForm
                    :routeDef="this.routeDef"
                    :createDef="this.billingDef"
                    :modelData="modelData"
                    ref="onboardformRenderer"
                  />
                </DxScrollView>
              </DxPopup>
            </div>
          </section>
        </div>
      </div>
    </div>
  </app-layout>
</template>
<style>
#elip {
  overflow: hidden;
  width: 260px;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.noselect {
  -webkit-touch-callout: none;
  /* iOS Safari */
  -webkit-user-select: none;
  /* Safari */
  -khtml-user-select: none;
  /* Konqueror HTML */
  -moz-user-select: none;
  /* Firefox */
  -ms-user-select: none;
  /* Internet Explorer/Edge */
  user-select: none;
  /* Non-prefixed version, currently supported by Chrome and Opera */
}

.img-company {
  width: 50px;
  height: 50px;
}

.no-decoration {
  text-decoration: none;
}

.no-decoration:hover {
  text-decoration: none;
}

.organisations-container {
  width: 50% !important;
  background: var(--white);
}

.ul-add-organisation {
  background-color: var(--blue);
}

.btn-submit {
  background-color: var(--blue);
}

/* progress css start here  */
.steps {
  list-style: none;
  margin: 0;
  padding: 0;
  display: table;
  table-layout: fixed;
  width: 100%;
  color: #929292;
  margin-top: 10px;
  height: 1rem;
}
.steps > .step {
  position: relative;
  display: table-cell;
  text-align: center;
  font-size: 0.875rem;
  color: #6d6875;
}
.steps > .step:before {
  content: attr(data-step);
  display: block;
  margin: 0 auto;
  background: #ffffff;
  border: 2px solid #e6e6e6;
  color: #e6e6e6;
  width: 2rem;
  height: 2rem;
  text-align: center;
  margin-bottom: -4.2rem;
  line-height: 1.9rem;
  border-radius: 100%;
  position: relative;
  z-index: 1;
  font-weight: 700;
  font-size: 1rem;
}
.steps > .step:after {
  content: "";
  position: absolute;
  display: block;
  background: #e6e6e6;
  width: 100%;
  height: 0.125rem;
  top: 1rem;
  left: 50%;
}
.steps > .step:last-child:after {
  display: none;
}
.steps > .step.is-complete {
  color: #6d6875;
}
.steps > .step.is-complete:before {
  content: "✓";
  color: #fff;
  background: #10b981;
  border: 2px solid #10b981;
}
.steps > .step.is-complete:after {
  background: #10b981;
}
.steps > .step.is-active {
  font-size: 1.25rem;
  margin-top: 10px;
}
.steps > .step.is-active:before {
  color: #fff;
  border: 2px solid #10b981;
  background: #10b981;
  margin-bottom: -4.9rem;
}

/**
 * Some Generic Styling
 */
*,
*:after,
*:before {
  box-sizing: border-box;
}

h1 {
  margin-bottom: 1.5em;
}

.steps {
  margin-bottom: 1em;
}
/* progress end here */
</style>

<script>
import AppLayout from "@/Layouts/AppLayout.vue";
import Welcome from "@/Jetstream/Welcome.vue";
import PageTitle from "@/Layouts/PageTitle.vue";
import JetNavLink from "@/Jetstream/NavLink.vue";
import BsOnBoardForm from "@include/forms/BsOnBoardForm";
import { DxScrollView } from "devextreme-vue/scroll-view";

import {
  DxColumn,
  DxFormItem,
  DxEditing,
  DxLookup,
  DxGrouping,
  DxColumnChooser,
  DxLoadPanel,
  DxToolbar,
  DxDataGrid,
  DxSelection,
  DxFilterRow,
  DxScrolling,
  DxPager,
  DxPaging,
} from "devextreme-vue/data-grid";
import {
  DxForm,
  DxSimpleItem,
  DxGroupItem,
  DxItem,
  DxLabel,
} from "devextreme-vue/form";
import { DxPopup, DxPosition, DxToolbarItem } from "devextreme-vue/popup";

export default {
  props: {
    productId: String,
    organisationId: String,
    subscriptionPlanId: String,
    subscriptionPriceId: String,
    //array billing Def with default value []
    billingDef: {
      type: Array,
      default: [],
    },
    ledgerData: Object,
  },

  components: {
    AppLayout,
    Welcome,
    PageTitle,
    JetNavLink,
    DxForm,
    DxSimpleItem,
    DxGroupItem,
    DxItem,
    DxLabel,
    DxPopup,
    DxPosition,
    DxToolbarItem,
    DxColumn,
    DxFormItem,
    DxEditing,
    DxLookup,
    DxGrouping,
    DxColumnChooser,
    DxLoadPanel,
    DxToolbar,
    DxDataGrid,
    DxSelection,
    DxFilterRow,
    DxScrolling,
    DxPager,
    DxPaging,
    BsOnBoardForm,
    DxScrollView,
  },
  data() {
    return {
      title: "Billing",
      combinedQuery: "",
      routeDef: "ledgers",
      createPopupVisible: false,
      saveButtonOptions: {
        icon: "save",
        text: "Save",
        onClick: this.saveRecord,
      },
      closeButtonOptions: {
        text: "Close",
        onClick: () => {
          this.createPopupVisible = false;
        },
      },
    };
  },
  methods: {
    getOrganisation() {
      axios.get("tenants/list").then((response) => {
        this.tenantData = response.data.results.data;
      });
    },
    goToOrderPage(id) {
      var data = {
        productId: this.productId,
        subscriptionPlanId: this.subscriptionPlanId,
        pricingId: this.subscriptionPriceId,
        organisationId: this.organisationId,
        billingId: id,
      };
      this.$inertia.post(route("marketplaces.placeorder"), data);
    },
    moveToBillingCreate() {
      alert("Wait for this features we are working on it");
      //this.$inertia.get("billingacc/create");
    },

    saveRecord() {
      // var data =this.$refs.onboardformRenderer.formData
      this.$refs.onboardformRenderer.formData.organisationId =
        this.organisationId;

      this.$inertia.post(
        route("marketplaces.onboard.ledgers", this.$refs.onboardformRenderer.formData)
      );
      this.createPopupVisible = false;
    },
    showCreatePopup() {
      this.createPopupVisible = true;
    },
  },
  mounted() {
    let urlParams = new URLSearchParams(window.location.search);
    //  this.combinedQuery="&product_id="+this.productId+"&organisation_id="+this.organisationId+"&sub_id="+this.subscriptionPlanId+"&price_id="+this.subscriptionPriceId;
    //this.getOrganisation();

    console.log("Ledger Data", this.ledgerData[0]);
  },
};
</script>